import { render, staticRenderFns } from "./config.vue?vue&type=template&id=5c23485d&"
import script from "./config.vue?vue&type=script&lang=js&"
export * from "./config.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\project\\文化宫\\code\\whg\\Web\\Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5c23485d')) {
      api.createRecord('5c23485d', component.options)
    } else {
      api.reload('5c23485d', component.options)
    }
    module.hot.accept("./config.vue?vue&type=template&id=5c23485d&", function () {
      api.rerender('5c23485d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/PMS/performancecenter/theater/config.vue"
export default component.exports